import React from "react";

import InfiniteScrollList from "../../../commonComponents/util/InfiniteScrollList";
import { formatDate, formatCurrency } from "../../../../lib/utils";

export default class ReconciliationPaymentsTable extends React.Component {
  state = { localSort: null };
  _isPrefetching = false;

  prefetchMorePages = async (maxExtraPages = 5) => {
    if (this._isPrefetching) return;
    this._isPrefetching = true;
    try {
      let nextPage = (this.props.page || 1) + 1;
      for (let i = 0; i < maxExtraPages; i++) {
        await this.props.getPayments(false, nextPage, this.props.results, this.props.sort);
        nextPage += 1;
      }
    } finally {
      this._isPrefetching = false;
    }
  };

  getPaymentsPaginated = async (page, sort, reset = false) => {
    // Handle client-side sorting for the checkbox column
    if (sort && sort.by === "selected") {
      if (!this.state.localSort || this.state.localSort.direction !== sort.direction) {
        this.setState({ localSort: sort });
      }
      if (reset) {
        // Start a small background prefetch so selected rows not yet loaded can appear
        setTimeout(() => this.prefetchMorePages(), 0);
        return;
      }
      return this.props.getPayments(false, page, this.props.results, this.props.sort);
    }
    if (this.state.localSort) this.setState({ localSort: null });
    return this.props.getPayments(reset, page, this.props.results, sort);
  };

  getTableRow = transaction => {
    const selected = (this.props.selected || []).some(
      trans => trans.transactionId === transaction.transactionId
    );

    return (
      <tr className="table-row" key={transaction.transactionId}>
        <td>
          <div className="custom-check-container">
            <input
              type="checkbox"
              id={`payment-${transaction.transactionId}`}
              className="custom-check"
              onChange={this.props.selectPayment.bind(null, transaction)}
              checked={selected}
            />
            <label htmlFor={`payment-${transaction.transactionId}`} className="secondary-text" />
          </div>
        </td>
        <td data-label="Check Number">
          <p>{transaction.referenceNumber}</p>
        </td>
        <td data-label="Date">
          <p>{formatDate(transaction.date)}</p>
        </td>
        <td data-label="Payee">
          <p>{transaction.details}</p>
        </td>
        <td data-label="Amount">
          <p>{formatCurrency(transaction.amount, this.props.isIsraeli)}</p>
        </td>
        <td data-label="Note">
          <i
            className={`material-icons ${!selected ? "disabled" : ""}`}
            onClick={() => {
              if (selected) {
                this.props.onClickTransactionNote(transaction.transactionId);
              }
            }}
          >
            {this.props.transactionNotes[transaction.transactionId] ? "note" : "note_add"}
          </i>
        </td>
      </tr>
    );
  };

  render() {
    const {
      data: { records, totalCount },
      hasMore,
      loading,
      page,
      results,
      sort,
      success
    } = this.props;

    const effectiveSort = this.state.localSort || sort;
    const baseRecords = Array.isArray(records) ? records : [];
    const selectedList = Array.isArray(this.props.selected) ? this.props.selected : [];
    const selectedIds = new Set(selectedList.map(trans => trans.transactionId));
    let displayRecords = baseRecords;
    if (effectiveSort && effectiveSort.by === "selected") {
      const selectedFromBase = baseRecords.filter(r => selectedIds.has(r.transactionId));
      const unselectedFromBase = baseRecords.filter(r => !selectedIds.has(r.transactionId));
      const selectedNotInBase = selectedList.filter(
        s => !baseRecords.some(r => r.transactionId === s.transactionId)
      );
      // De-duplicate selected: prefer base version when available
      const selectedCombinedMap = new Map();
      selectedFromBase.forEach(r => selectedCombinedMap.set(r.transactionId, r));
      selectedNotInBase.forEach(s => {
        if (!selectedCombinedMap.has(s.transactionId)) selectedCombinedMap.set(s.transactionId, s);
      });
      const selectedCombined = Array.from(selectedCombinedMap.values());
      displayRecords =
        effectiveSort.direction === "Descending"
          ? [...selectedCombined, ...unselectedFromBase]
          : [...unselectedFromBase, ...selectedCombined];
    }

    return (
      <InfiniteScrollList
        name="reconciliation payments"
        page={page}
        totalCount={totalCount}
        resultsView={results}
        sort={effectiveSort}
        loading={loading}
        success={success}
        renderRecord={this.getTableRow}
        columns={[
          { title: "Cleared", sortable: true, id: "selected", defaultDirection: "Descending" },
          { title: "Check Number", sortable: true, id: "reference" },
          {
            title: "Date",
            sortable: true,
            id: "date",
            defaultDirection: "Ascending"
          },
          { title: "Payee", sortable: true, id: "details" },
          { title: "Amount", sortable: true, id: "amount" },
          { title: "Note", sortable: false, id: "note" }
        ]}
        records={displayRecords}
        hasMore={hasMore}
        showFooter={false}
        getRecords={this.getPaymentsPaginated}
        hideScrollToTopButton={true}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/accountingComponents/fundDetails/NewBankReconciliation/ReconciliationPaymentsTable.jsx